import { IMenuEvaluators } from '@zing/shared/components/menu/state/content/store/contracts'
import { Evaluation } from '.'
import {Score} from "iebt-zing-storybook";

export const bankersRound = (number: number): number => {
  const value = number * 100
  const roundValue = Math.round(value)
  const bankerRound = value % 1 === 0.5 ? (roundValue % 2 === 0 ? roundValue : roundValue - 1) : roundValue
  const result = bankerRound / 100
  return result
}

export const criterionCount = (evaluation: Evaluation): number => {
  let count = 0
  evaluation.sections.forEach(item => {
    count += Number(item.answers.length)
  })
  return count
}

export const criterionIsMet = (evaluation: Evaluation): number => {
  let count = 0
  evaluation.sections.forEach(item => {
    item.answers.forEach(res => {
      if (res.value !== null) {
        count += 1
      }
    })
  })
  return count
}

export class ScoreResult {
  constructor(public readonly currentValue: number, public readonly maxValue: number) {
  }
}

export const calculateScore = (evaluation: Evaluation): ScoreResult => {
  let dividend = 0
  let divisor = 0
  const maxScore = 5;
  evaluation.sections.forEach(item => {
    item.answers.forEach(res => {
      if (res.value !== null) {
        dividend += (res.value * res.weight)
        divisor += res.weight
      }
    })
  })
  const division = (dividend / divisor)
  if (Number.isNaN(division)) return new ScoreResult(0, maxScore)
  else return new ScoreResult(division, maxScore)
}

export const currentSection = (sectionIndex: number, sectionsLength: number): string => {
  const value = `${sectionIndex + 1} de ${sectionsLength}`
  return value
}

export const goToSectionTop = (elementId: string): void => {
  const element = document.getElementById(elementId)
  element?.scroll({ top: 0, behavior: 'smooth' })
}

// TO DO: Melhorar essa lógica
export const changeSolutionPoints = (menuEvaluator: IMenuEvaluators, challengeId: string, stepId: string, resolverId: string, ideaId: string, evaluationPoints: string): IMenuEvaluators => {
  menuEvaluator.rows?.forEach((row) => {
    if (row.id === challengeId) {
      row.evaluation.steps.forEach((step) => {
        if (step.id === stepId) {
          step.resolvers.forEach((resolver) => {
            if (resolver.id === resolverId) {
              resolver.solutions.forEach((solution) => {
                if (solution.id === ideaId) {
                  solution.points = Number(evaluationPoints)
                }
              })
            }
          })
        }
      })
    }
  })
  return menuEvaluator
}
